import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "qtl-bill" }

import { computed } from "vue";
import { TableDataCellDisplayType } from "@/models/etc/types";
import type { CellDataBill, TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";


export default /*@__PURE__*/_defineComponent({
  __name: 'BillCellElementLite',
  props: {
    element: {}
  },
  setup(__props: any) {

const props = __props;

// Возвращаем именно объекты Bill (как legacy BillCellElement.getElements),
// дальше их форматирует bill-row. Для не-Bill ничего не рисуем.
const bills = computed(() => {
  if (props.element.DisplayType === TableDataCellDisplayType.Bill) {
    return (props.element.Data as CellDataBill[]).map((d) => d.Bill);
  }
  return [];
});

return (_ctx: any,_cache: any) => {
  const _component_bill_row = _resolveComponent("bill-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bills.value, (rec, i) => {
      return (_openBlock(), _createBlock(_component_bill_row, {
        key: i,
        el: rec
      }, null, 8, ["el"]))
    }), 128))
  ]))
}
}

})